import { render, staticRenderFns } from "./PlatformsHeader.vue?vue&type=template&id=6a4b04d0&"
import script from "./PlatformsHeader.vue?vue&type=script&lang=ts&"
export * from "./PlatformsHeader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports